import React from 'react';
import './TransactionList.css';

function TransactionList({ statements, loading, sortOrder, onSortChange }) {
  console.log('TransactionList received', statements.length, 'statements, first ID:', statements[0]?.id);
  
  const toggleSort = () => {
    onSortChange(prev => prev === 'asc' ? 'desc' : 'asc');
  };
  
  if (loading) {
    return (
      <div className="transaction-list">
        <h3>Recent Transactions</h3>
        <div className="loading-skeleton">Loading transactions...</div>
      </div>
    );
  }

  if (!statements || statements.length === 0) {
    return (
      <div className="transaction-list">
        <h3>Recent Transactions</h3>
        <p className="no-transactions">No transactions found for the selected period</p>
      </div>
    );
  }

  return (
    <div className="transaction-list">
      <h3>Recent Transactions ({statements.length})</h3>
      <div className="transaction-table-wrapper">
        <table className="transaction-table">
          <thead>
            <tr>
              <th className="sortable-header" onClick={toggleSort}>
                Date 
                <span className="sort-indicator">
                  {sortOrder === 'desc' ? '↓' : '↑'}
                </span>
              </th>
              <th>Transaction ID</th>
              <th>Direction</th>
              <th>Partner</th>
              <th>Comment</th>
              <th>Amount</th>
              <th>Type</th>
            </tr>
          </thead>
          <tbody>
            {statements.map((stmt) => (
              <tr key={stmt.id} className={`transaction-row ${stmt.direction?.toLowerCase()}`}>
                <td className="date">
                  {formatDate(stmt.finishedAt || stmt.createdAt)}
                </td>
                <td className="transaction-id">
                  <span className="mono">{stmt.id}</span>
                </td>
                <td className="direction">
                  <span className={`direction-badge ${stmt.direction?.toLowerCase()}`}>
                    {stmt.direction === 'INCOMING' ? '↓' : '↑'} {stmt.direction}
                  </span>
                </td>
                <td className="partner">
                  {stmt.partnerName || '-'}
                </td>
                <td className="comment">
                  {stmt.comment || '-'}
                </td>
                <td className={`amount ${stmt.direction?.toLowerCase()}`}>
                  {stmt.direction === 'INCOMING' ? '+' : '-'}
                  {formatAmount(stmt.amount)} {stmt.currency}
                </td>
                <td className="type">
                  <span className="type-badge">{stmt.fiscalType || 'BASE'}</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function formatDate(dateString) {
  if (!dateString) return '-';
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
}

function formatAmount(amount) {
  if (amount === undefined || amount === null) return '0.00';
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(Math.abs(amount));
}

export default TransactionList;